// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 443 ? "about" : chunkId) + "." + {"130":"cb2a8ca6","443":"c513425e","620":"1f2d9e12"}[chunkId] + ".css";
};